import { render, staticRenderFns } from "./SubmissionsCard.vue?vue&type=template&id=5504fcd6&scoped=true&"
import script from "./SubmissionsCard.vue?vue&type=script&lang=ts&"
export * from "./SubmissionsCard.vue?vue&type=script&lang=ts&"
import style0 from "./SubmissionsCard.vue?vue&type=style&index=0&id=5504fcd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5504fcd6",
  null
  
)

export default component.exports